import { Nullable } from 'src/core/common/domain/types/types';
import { TaskActions } from 'src/core/master-data/domain/task-actions';

export type ApiAvailableActions = Nullable<Array<TaskActions>>;

/*
 * A level that omits the field inherits the actions of the level above, which the domain models as null.
 * A level that sends it as null grants no action at all, the same as one that sends an empty list.
 */
export const availableActionsFromApi = (availableActions?: ApiAvailableActions): Nullable<Array<TaskActions>> =>
  availableActions === undefined ? null : availableActions ?? [];
